import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatIconModule, MatInputModule, MatSelectModule, MatSlideToggleModule } from '@angular/material';

import { UserLoginComponent } from './user-login/user-login.component';
import { StripePipe } from './stripe.pipe';
import { KeysPipe, InitialsPipe } from './keys.pipe';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { FooterBarComponent, NavBarComponent } from './nav-bar/nav-bar.component';
import { TimeInputComponent, TimeDirective } from './time-input/time-input.component';
import { SimpleTimePickerComponent } from './simple-timepicker';
import {AlertPanelComponent} from "./alert-panel";
import { CollapsibleComponent } from "./collapsible.component";

@NgModule({
    imports: [
        CommonModule,
        MatInputModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatIconModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule
    ],
    declarations: [UserLoginComponent, StripePipe, KeysPipe, InitialsPipe, LoadingSpinnerComponent, NavBarComponent, FooterBarComponent,
        TimeInputComponent, TimeDirective, SimpleTimePickerComponent, AlertPanelComponent, CollapsibleComponent],
    exports: [UserLoginComponent, StripePipe, FormsModule, KeysPipe, InitialsPipe, LoadingSpinnerComponent, NavBarComponent,
        FooterBarComponent, TimeInputComponent, SimpleTimePickerComponent, AlertPanelComponent, CollapsibleComponent],
    entryComponents: [AlertPanelComponent, CollapsibleComponent]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts